/**
 * Previous Section Component
 *
 * Reusable component for the "Previous" navigation section
 * used across onboarding modals.
 *
 * Features:
 * - Top border divider
 * - Centered "Previous" button with left arrow
 * - Consistent spacing (24px padding top, 16px padding bottom)
 */
"use client";

import Image from "next/image";

import { colors } from "@/styles/design-tokens";

interface PreviousSectionProps {
  onBack: () => void;
  paddingTop?: string;
  paddingBottom?: string;
}

export function PreviousSection({
  onBack,
  paddingTop = "50px",
  paddingBottom = "16px",
}: PreviousSectionProps) {
  return (
    <div
      className="flex items-center justify-center border-t"
      style={{
        borderColor: colors.divider.divider1,
        paddingTop,
        paddingBottom,
      }}
    >
      <button
        type="button"
        onClick={onBack}
        className="flex items-center gap-2 transition-opacity hover:opacity-70"
      >
        <div className="rotate-180">
          <Image src="/icons/arrow-right.svg" alt="" width={14} height={14} />
        </div>
        <span className="text-overline text-ink">Previous</span>
      </button>
    </div>
  );
}
